/** 1. Tag it as a client component */
"use client";
import { storyblokInit, apiPlugin } from "@storyblok/react";
import StoryblokComponents from "@/storyblok/components";
import { accessToken } from "@/storyblok/credentials";

const components = StoryblokComponents;

storyblokInit({
  accessToken: accessToken,
  use: [apiPlugin],
  components,
});

export default function StoryblokProvider({ children }) {
  return <>{children}</>;
}
